module.exports = __webpack_public_path__ + "img/icon_gushumingmu_zaixian.dc19929b.svg";